// extracted by mini-css-extract-plugin
export default {"app":"App_app__Ea4Fn","footer":"App_footer__Fe2pe","footerLink":"App_footerLink__1KsYe"};